import i18n from 'i18next';
import icu from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import en from './en';

const resources = {
  en,
} as const;

// The instance every package shares. Packages above this one add their own namespaces with
// `addResourceBundle`, so there is exactly one i18next in the tree no matter who is mounted.
// No default namespace: nothing here writes an unprefixed key, and the package that owns the
// default (`@sparklayer-io/spark-dash-pages`) sets it when it registers.
i18n
  .use(icu)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    defaultNS: false,
  })
  .catch((err) => {
    console.log('Failed to set up i18n');
    throw err;
  });

export default i18n;
